// extracted by mini-css-extract-plugin
export default {"botao_salvar":"BotaoSalvar_botao_salvar__QsMch"};